import { createVanIconComponent } from "./van"

const GiftOutlined = createVanIconComponent("gift-o")
export default GiftOutlined
